import React, { useState, useEffect, useRef } from "react";

import CustomModal from "../../CustomModal";

import api from "../../../helpers/api.js";
import Parser from "../../../helpers/parser.js";

import * as Material from "@mui/material";

import "./styles.css";

import CloseIcon from "@mui/icons-material/Close";
import CakeIcon from "@mui/icons-material/Cake";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";

import MainButton from "../../SmallComponents/MainButton";
import Feed from "../../Feed";
import Box from "../../Box";

import { sendMessageTo } from "../../../contexts/ChatContext";
import { useChallenge } from "../../../contexts/ChallengeContext";

const UserModal = () => {
  const [open, setOpen] = useState(false);

  const REF_userId = useRef();

  const [user, setUser] = useState({});

  console.log(REF_userId);

  useEffect(() => {
    if (open) {
      handleLoadUser();
    } else {
      setUser({});
    }
  }, [open]);

  window.openUserDetails = (userId) => {
    if (!userId) return false;
    REF_userId.current = userId;
    setOpen(true);
    return true;
  };

  async function handleLoadUser() {
    try {
      const { data } = await api.get(
        "customers/details?id=" + REF_userId.current
      );
      console.log(data);
      setUser(data);
    } catch (e) {
      console.log("Error loading user");
      console.log(e);
    }
  }

  async function handleDeleteUser() {
    window.openConfirm({
      title: "Remover usuário",
      headline: "Atenção!",
      subtitle:
        'Você realmente deseja remover permanentemente o usuário "' +
        user?.user.username?.split(" ")[0] +
        '"?',
      buttons: [
        {
          text: "Apagar permanentemente",
          onClick: handleExecuteDelete,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Manter usuário",
          variant: "text",
        },
      ],
    });

    async function handleExecuteDelete() {
      try {
        const { data } = await api.delete("/customers?id=" + user?.user.id);

        if (data.success) {
          window.setSnackbar("Usuário deletado com sucesso");
          setOpen(false);
        } else {
          window.setSnackbar(
            "Houve um erro ao apagar este usuário, tente novamente em alguns minutos"
          );
        }

        console.log("Deletion result", data);
      } catch (e) {
        window.setSnackbar(
          "Houve um erro ao apagar este usuário, tente novamente mais tarde"
        );
      }
    }
  }

  return (
    <CustomModal
      maxWidth={950}
      hideSecondaryButton={true}
      loading={false}
      customTitle={
        <div className="user-header pl-1 pr-3 py-1">
          {user?.user ? (
            <>
              {user?.user?.avatar && (
                <img src={user?.user.avatar} className="user-modal-avatar" />
              )}
              <h3 className="grow-1">{user?.user?.username}</h3>
              <MainButton
                onClick={() => {
                  const chat = user.user;
                  chat.user_id = chat.id;
                  sendMessageTo(chat);
                  setOpen(false);
                  setUser({});
                }}
                label="Enviar mensagem"
                color="white"
                endIcon={<SendIcon />}
                shadow={false}
              />
              <MainButton
                onClick={handleDeleteUser}
                label="Apagar"
                color="error"
                endIcon={<DeleteIcon color="error" />}
                shadow={false}
              />
            </>
          ) : (
            <>
              <Material.Skeleton
                height={35}
                width={35}
                className="user-modal-loader-bar"
              />
              <Material.Skeleton
                height={35}
                width={200}
                className="user-modal-loader-bar grow-1"
              />
              <Material.Skeleton
                height={35}
                width={90}
                className="user-modal-loader-bar"
              />
              <Material.Skeleton
                height={35}
                width={90}
                className="user-modal-loader-bar"
              />
            </>
          )}
        </div>
      }
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      modalClass="user-details-modal"
      bottomButtonsOrientation="vertical"
      bodyComponent={
        <>
          <div className="user-details-container">
            {user?.user ? (
              <>
                <Cards.Contact user={user} />
                <Cards.Challenges
                  user={user}
                  onChallengeUnsubscribe={handleLoadUser}
                />
                <Cards.Subscriptions user={user} />
              </>
            ) : (
              <div>
                <Material.Skeleton
                  height={180}
                  className="user-modal-loader-bar mb-1"
                />
                <Material.Skeleton
                  height={180}
                  className="user-modal-loader-bar mb-1"
                />
                <Material.Skeleton
                  height={180}
                  className="user-modal-loader-bar mb-1"
                />
              </div>
            )}
          </div>
          {open && (
            <Feed
              fitContentHeight={true}
              filterByUser={user?.user}
              key={user?.user?.id}
              containerProps={{
                style: {
                  top: '0px'
                }
              }}
            />
          )}
        </>
      }
    />
  );
};

export default UserModal;

const Cards = {
  Contact: ({ user }) => {
    if (!user?.user) return null;

    const { email, phone, born_on } = user.user;

    function handleOpenWhatsApp() {
      window.open(
        "https://api.whatsapp.com/send/?phone=" +
          phone.replace(/[^\d]/g, "") +
          "&text&type=phone_number&app_absent=0"
      );
    }

    function getBirthDays() {
      const [year, month, day] = born_on.split("-");
      const dataAtual = new Date();
      let birthCurrentYear = new Date(dataAtual.getFullYear(), month - 1, day);
      if (dataAtual > birthCurrentYear) {
        birthCurrentYear = new Date(
          dataAtual.getFullYear() + 1,
          month - 1,
          day
        );
      }
      const diffMillis = birthCurrentYear - dataAtual;
      return Math.ceil(diffMillis / (1000 * 60 * 60 * 24));
    }

    return (
      <Box.Container title="Dados do contato">
        <Box.Row>
          <CakeIcon
            style={{ transform: "translateY(-4px)" }}
            fontSize="small"
          />
          <Material.Divider orientation="vertical" flexItem />
          <span className="box-row-title">Aniversário: </span>
          <span> {born_on ? Parser.date.ddmmyyyy(born_on) : "-"}</span>
          {born_on && (
            <small style={{ opacity: 0.7 }}>
              (
              {getBirthDays() > 350
                ? "Foi a " + (365 - getBirthDays())
                : "Daqui a " + getBirthDays()}{" "}
              dias)
            </small>
          )}
        </Box.Row>
        <Box.Row>
          <EmailIcon fontSize="small" />
          <Material.Divider orientation="vertical" flexItem />
          <span className="box-row-title">Email: </span>
          <span> {email}</span>
        </Box.Row>
        <Box.Row>
          <PhoneIcon fontSize="small" />
          <Material.Divider orientation="vertical" flexItem />
          <span className="box-row-title">Celular: </span>
          <span className="grow-1"> {Parser.phone(phone)}</span>

          <Material.Button
            size="small"
            variant="contained"
            className="whatsapp-button"
            onClick={handleOpenWhatsApp}
            endIcon={<WhatsAppIcon />}
          >
            Enviar WhatsApp
          </Material.Button>
        </Box.Row>
      </Box.Container>
    );
  },

  Challenges: ({ user, onChallengeUnsubscribe }) => {
    const { handleOpenRemoveMemberTool } = useChallenge();

    if (!user?.user) return null;

    let { challenges } = user;

    async function handleUnsubscribeChallenge(id) {
      console.log("Unsubscribe from", id);

      handleOpenRemoveMemberTool({
        id: user.user.id,
        challenge_id: id,
        onDelete: onChallengeUnsubscribe,
        username: user.user.username,
      });
    }

    return (
      <Box.Container title="Comunidades">
        {challenges.map((challenge) => (
          <Box.Row baloon key={challenge.id}>
            <img src={challenge.banner} className="challenge-banner-row" />

            <Material.Divider orientation="vertical" flexItem />
            <small className="points-badge">{challenge.points || 0} pts</small>
            <span className="grow-1 box-row-title">{challenge.name}</span>

            <Box.RowCloseButton
              tooltip="Desinscrever da comunidade"
              onClick={() => handleUnsubscribeChallenge(challenge.id)}
            />
          </Box.Row>
        ))}
      </Box.Container>
    );
  },

  Subscriptions: ({ user }) => {
    if (!user?.user) return null;

    const { subscriptions, payment_history } = user;

    async function handleUnsubscribeProduct(id) {
      console.log("Unsubscribe from", id);
    }

    return (
      <Box.Container title="Pagamentos">
        {subscriptions.map((product) => (
          <Box.Row baloon key={product.payment_id}>
            <small>
              R${Parser.price.brl(product.price)} /{" "}
              {Parser.interval.noun(product.interval)}
            </small>
            <Material.Divider flexItem orientation="vertical" />
            <span className="grow-1 box-row-title">{product.product_name}</span>
            <small>
              Venc.: {Parser.date.ddmmyyyy(product.renewed_until.split(" ")[0])}
            </small>
            <small
              className={
                "product-expiration-badge box-row-title " +
                (product.active ? "active" : "inactive")
              }
            >
              {product.active ? "Ativo" : "Inativo"}
            </small>
            {/*<Box.RowCloseButton
              tooltip="Cancelar assinatura"
              onClick={() => handleUnsubscribeProduct(product.id)}
            />*/}
          </Box.Row>
        ))}

        {payment_history?.length ? (
          <span className="box-row-title pt-2">Histórico de pagamentos </span>
        ) : (
          <i>"Nenhum pagamento identificado"</i>
        )}

        {payment_history.map((product) => (
          <Box.Row baloon key={product.payment_id}>
            <small className={"product-expiration-badge box-row-title  active"}>
              Pago
            </small>
            <small>R${Parser.price.brl(product.price)}</small>
            <Material.Divider flexItem orientation="vertical" />
            <span className="grow-1 box-row-title">{product.product_name}</span>
            <small>{Parser.date.ddmmyyyy(product.paid_at.split(" ")[0])}</small>
          </Box.Row>
        ))}
      </Box.Container>
    );
  },
};
